/**
 * Format date
 * @param timestamp
 * @returns {string}
 */
export const formatDate = (timestamp: number | string) => {
	const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
		date = new Date(timestamp),
		year = date.getFullYear(),
		month = monthNames[date.getMonth()], // months are zero indexed
		day = date.getDate(),
		hour = date.getHours(),
		minutes = date.getMinutes(),
		minutesFormatted = minutes < 10 ? "0" + minutes : minutes;

	return `${day} ${month} ${year} ${hour}:${minutesFormatted}`;
}

/**
 *
 * @param arrayOfObjects
 * @param key
 * @returns {*}
 */
export const sortAlphabetically = (arrayOfObjects: Array<any>, key: string) => {
	return arrayOfObjects.sort((a, b) => a[key].localeCompare(b[key]));
}


/**
 * Decode URI without throwing an error if there is a percentage ('%') present in string
 *
 * @param input
 */
export const safeDecodeURIComponent = (input: string) => {
	if (!input) {
		return input;
	}

	return decodeURIComponent(input.replace(/%(?![0-9][0-9a-fA-F]+)/g, '%25'));
}